import React from "react"
import { useShopBanners } from "popopo-lib-front/firestore-access"
import { firestore } from "../core"
import { Paths } from "../paths"

import { formatDateTime } from "../lib/util"
import { NavLink } from "react-router-dom"
import { Button } from "react-bootstrap"

export const Shop = () => {
  const banners = useShopBanners(firestore, 50)

  return (<>
    <div className="row gy-5">
      <div className="col-12 d-flex flex-column align-items-center gap-3">
        <h2 className="mb-4">ショップ</h2>

        <div className="d-flex gap-3">
          <NavLink to={Paths.items.path}>
            <Button variant="secondary" className="btn-lg">
              <i className="fas fa-shop me-2"></i>
              アイテム
            </Button>
          </NavLink>
        </div>
      </div>
    </div>

    <div className="container py-4">
      <h2 className="mb-4">ショップバナー</h2>
      {banners === "loading" ? (
        <div className="text-center py-5">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">読み込み中...</span>
          </div>
        </div>
      ) : banners.length === 0 ? (
        <div className="alert alert-info">
          <i className="fas fa-info-circle me-2"></i>
          現在公開中のショップバナーはありません。
        </div>
      ) : (
        <div className="list-group">
          {banners.map((banner, index) => (
            <div
              key={banner.id}
              className={`list-group-item ${0 < index ? 'border-top' : ''}`}
              style={{ marginBottom: '8px' }}
            >
              <div className="d-flex w-100 justify-content-between align-items-start">
                <div>
                  <h5 className="mb-2">
                    Banner ID: {banner.id}
                    {0 < banner.priority && (
                      <span className="badge bg-warning ms-2">優先度: {banner.priority}</span>
                    )}
                  </h5>
                  <p className="mb-1">
                    <strong>表示場所:</strong> {banner.display_location}
                  </p>
                  <p className="mb-1">
                    <strong>遷移先URI:</strong> <a href={banner.uri} target="_blank" rel="noopener noreferrer">{banner.uri}</a>
                  </p>
                  <p className="mb-1">
                    <strong>画像ID:</strong> {banner.managed_image_id}
                  </p>
                  {banner.image_text && (
                    <p className="mb-1">
                      <strong>画像テキスト:</strong> {banner.image_text}
                    </p>
                  )}
                  <p className="mb-1">
                    <strong>表示期間:</strong> {formatDateTime(banner.display_period.start_at)} 
                    {banner.display_period.end_at ? ` - ${formatDateTime(banner.display_period.end_at)}` : ' - 無期限'}
                  </p>
                  <p className="mb-1">
                    <strong>ステータス:</strong> 
                    <span className={`badge ${banner.status === 'public' ? 'bg-success' : 'bg-secondary'} ms-2`}>
                      {banner.status}
                    </span>
                  </p>
                  <p className="mb-0">
                    <strong>期間状態:</strong> 
                    <span className={`badge ${banner.display_period_state.active ? 'bg-primary' : 'bg-secondary'} ms-2`}>
                      {banner.display_period_state.active ? '有効' : '無効'}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  </>)
}
